import { useState, useEffect } from "react";

export function useTimer(competition) {
  const [timer, setTimer] = useState("");

  useEffect(() => {
    if (competition && competition.state && competition.state.start && competition.state.end) {
      const initTime = setInterval(() => {
        let t;
        let text;
        let untilEnd =
          Date.parse(competition.state.end) - Date.parse(new Date());
        let untilStart =
          Date.parse(competition.state.start) - Date.parse(new Date());

        if (untilStart > 0) {
          t = Date.parse(competition.state.start) - Date.parse(new Date());
          text = `Starts in  `;
        } else if (untilStart <= 0) {
          t = untilEnd;
          text = `Ends in  `;
        }
        let seconds = Math.floor((t / 1000) % 60);
        let minutes = Math.floor((t / 1000 / 60) % 60);
        let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        let days = Math.floor(t / (1000 * 60 * 60 * 24));

        let resultTime = `${text} ${days <= 0 ? "" : days + "d "}  ${
          hours <= 0 ? "" : hours + "h "
        } ${minutes <= 0 ? "" : minutes + "m "} ${
          minutes < 0 && seconds < 0 ? "" : seconds
        }s`;

        if (untilEnd === 0) {
          text = `Finished`;
        }

        setTimer(resultTime);
      }, 1000);
      return () => clearInterval(initTime);
    }
  }, [competition]);

  return timer;
}
